import { render, staticRenderFns } from "./relatorio_dos_estudantes.vue?vue&type=template&id=dca698b2&scoped=true&"
import script from "./relatorio_dos_estudantes.vue?vue&type=script&lang=js&"
export * from "./relatorio_dos_estudantes.vue?vue&type=script&lang=js&"
import style0 from "./relatorio_dos_estudantes.vue?vue&type=style&index=0&id=dca698b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca698b2",
  null
  
)

export default component.exports